import { FormEvent, useState } from 'react';

import { ITokenSale, useApproveTokenSaleMutation } from '@entities/trades/token-sell';
import { FormItemWithError } from '@shared/components/Form';
import { useModal } from '@shared/components/Modal';
import { trimDecimalPart } from '@shared/utils/formatAmount';

interface IProps<T> {
  tokenSale: T;
  refetch: () => void;
}

export const ApproveTokenSale = <T extends ITokenSale>({ tokenSale, refetch }: IProps<T>) => {
  const { id, customer_transaction_id } = tokenSale;

  const [actualAmount, setActualAmount] = useState(tokenSale.amount);
  const [utr, setCustomerUtr] = useState(customer_transaction_id);
  const [reason, setReason] = useState('transaction_found_in_statement');

  const [approveTokenSale, { isLoading, isError, error, isSuccess }] =
    useApproveTokenSaleMutation();

  const { closeModal } = useModal();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const result = await approveTokenSale({
        id,
        actual_amount: String(actualAmount),
        reason,
        customer_transaction_id: utr,
      });

      if ('data' in result) {
        closeModal();
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <h2>Approve Token Sale</h2>
      <form className='popup-form' onSubmit={handleSubmit}>
        <FormItemWithError
          name='actual_amount'
          label='Actual Amount'
          isError={isError}
          error={error}
          secondName='tokenSale'
        >
          <input
            type='text'
            name='actual_amount'
            id='actual_amount'
            defaultValue={`${trimDecimalPart(actualAmount)}`}
            onChange={e => setActualAmount(e.target.value)}
          />
        </FormItemWithError>
        <FormItemWithError
          name='customer_transaction_id'
          label='UTR'
          isError={isError}
          error={error}
        >
          <input
            type='text'
            name='customer_transaction_id'
            id='customer_transaction_id'
            defaultValue={utr}
            onChange={e => setCustomerUtr(e.target.value)}
          />
        </FormItemWithError>

        <FormItemWithError name='reason' label='Reason' isError={isError} error={error}>
          <select
            name='reason'
            id='reason'
            defaultValue={reason}
            onChange={e => setReason(e.target.value)}
          >
            <option value='transaction_found_in_statement'>Transaction found in statement</option>
            <option value='test'>Test</option>
          </select>
        </FormItemWithError>

        {isSuccess && <div className='form-success'>Successfully approved</div>}

        <div className='form-submit'>
          <button type='submit' disabled={isLoading}>
            Approve
          </button>
          <button type='button' className='secondary-btn' onClick={closeModal}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};
